(function($, duo, undefined) {

	"use strict";

	/**
	 * Trap the tab-key inside a container
	 * @class KeyboardTrap
	 */
	class KeyboardTrap {

		/**
		 * Creates an instance of KeyboardTrap
		 * @param {string} selector css selector for the trap container
		 */
		constructor(selector) {
			this._selector = selector;
			this._element = $(selector);

			this._firstFocusable = null;
			this._lastFocusable = null;
			this._onKeyDown = this._onKeyDown.bind(this);

			this._trapIsActive = false;

			// setup:
			this._setup();
		} /* constructor */

		_setup() {
			// get the first and the last focusable elements of the container element:
			// (note: this won't work properly if the elements have "visibility: hidden")
			const focusableElements = this._element.find(this.constructor.focusableElementsString).filter(':visible');
			this._firstFocusable = focusableElements[0];
			this._lastFocusable = focusableElements[focusableElements.length - 1];
		} /* _setup */

		_onKeyDown(event) {

			// we need a first-focusable and a last-focusable
			// in order for the trap to work:
			if (!(this._firstFocusable && this._lastFocusable)) {
				event.preventDefault();
				return;
			}

			// Check for tab key presses:
			// -> if we're on the last focusable item, and we tab, we need to
			//    focus the first focusable item; if we're on the first focusable
			//    item and we tab back (with shift+tab), we need to focus the
			//    last focusable item
			if (event.keyCode === 9) {

				// -> shift+tab:
				if (event.shiftKey) {
					if (document.activeElement === this._firstFocusable) {
						event.preventDefault();
						this._lastFocusable.focus();
					}
				// -> tab:
				} else {
					if (document.activeElement === this._lastFocusable) {
						event.preventDefault();
						this._firstFocusable.focus();
					}
				}

			}
		} /* _onKeyDown */

		/**
		 * Trap the tab key;
		 * call the unTrap function to stop
		 */
		trap() {
			// set trap active:
			this._trapIsActive = true;
			// attach event listener:
			this._element.on('keydown.keyboardtrap', this._onKeyDown);
			// make the first item focusable:
			if (this._firstFocusable) {
				this._firstFocusable.focus();
			} else {
				this._element.focus();
			}
		} /* trap */

		/**
		 * Free the tab key
		 */
		unTrap() {
			// set trap inactive:
			this._trapIsActive = false;
			// remove event listener:
			this._element.off('keydown.keyboardtrap');
		} /* unTrap */

		/**
		 * Getter - returns state of the keyboard trap
		 */
		get isActive() {
			return this._trapIsActive;
		} /* isActive */

		/**
		 * CSS query string for focusable elements
		 * @readonly
		 * @static
		 */
		static get focusableElementsString() {
			return [
				'a[href]:not([tabindex^="-"]):not([inert])',
				'area[href]:not([tabindex^="-"]):not([inert])',
				'button:not([disabled]):not([inert])',
				'input:not([disabled]):not([inert])',
				'select:not([disabled]):not([inert])',
				'textarea:not([disabled]):not([inert])',
				'datalist:not([tabindex^="-"]):not([inert])',
				'iframe:not([tabindex^="-"]):not([inert])',
				'object:not([tabindex^="-"]):not([inert])',
				'embed:not([tabindex^="-"]):not([inert])',
				'[tabindex]:not([tabindex^="-"]):not([inert])',
				'[contenteditable]:not([tabindex^="-"]):not([inert])',
				'audio[controls]',
				'video[controls]',
				'summary:not([tabindex^="-"]):not([inert])',
			].join();
		} /* focusableElementsString */

	} /* KeyboardTrap */

	duo.KeyboardTrap = KeyboardTrap;

})(jQuery, window.duo = window.duo || {});
